/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionsHitlReportDto } from '../../models/submissions-hitl-report-dto';

export interface FactorHitlReportGet$Params {
  fromDate?: string;
  toDate?: string;
}

export function factorHitlReportGet(http: HttpClient, rootUrl: string, params?: FactorHitlReportGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubmissionsHitlReportDto>>> {
  const rb = new RequestBuilder(rootUrl, factorHitlReportGet.PATH, 'get');
  if (params) {
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubmissionsHitlReportDto>>;
    })
  );
}

factorHitlReportGet.PATH = '/Factor/hitl-report';
